import 'assets/style/common.scss'
import 'assets/style/components/img-register.scss'
import { ImageSlider } from 'components'

export default function ImageViewer({ imgSrc }) {
  console.log(imgSrc)
  return (
    <>
      <div className="wrapper img-register" style={{ marginBottom: '68px' }}>
        {Array.isArray(imgSrc) && imgSrc.length > 1 ? (
          <ImageSlider data={imgSrc} />
        ) : (
          <div className="img-box flex-align-center mt16">
            <img src={imgSrc} style={{ width: '100%' }} alt="" />
          </div>
        )}
      </div>
    </>
  )
}
